import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryHasSessionConfirm = props => (
	<Confirm
		btOne={localize('my_library_active_session_start')}
		btTwo={localize('my_library_active_session_resume')}
		alertMessage={localize('my_library_active_session_message_1')}
		actionButtonType={0}
		actionOne={() => {
			props.actions.launchNewSession(props.presentation_uid)
		}}
		actionTwo={() => {
			props.actions.resumeSession(props.presentation_uid, props.session_uid)
		}}
		closeAction={() => {
			props.actions.cancelSessionLaunch()
		}}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		launchNewSession: myLibraryActions.launchNewSession,
		resumeSession: myLibraryActions.resumeActiveSession,
		cancelSessionLaunch: myLibraryActions.cancelSessionLaunch,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryHasSessionConfirm)
